import { TimeRangeWidget } from './widgets/timerange.js';

export { widgetRegistry };

/**
 * Registry of widgets.
 * @memberof vef.data.dasf
 */
const widgetRegistry = {
    "timerange": TimeRangeWidget,
};
